// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__W6BVR","title":"Navbar_title__hAGxi"};